import { PaymentProvidersList } from '../components/PaymentProvidersList';

import { useDepartmentStore } from '@/stores/department';

export const PaymentProvidersPage = () => {
  const department = useDepartmentStore((state) => state.selected);
  return <PaymentProvidersList department={department} />;
};
